import React, { useState } from "react";
import { Node } from "./canvas-utils";
import { Button, FormHelperText, Input } from "@mui/material";

const MAX_INSTAGRAM_TEXT_LENGTH = 1000;

interface NodeTextFormProps {
  node: Node | null;
  onSave: (text: string) => void;
}

const NodeTextForm = ({ node, onSave }: NodeTextFormProps) => {
  const [text, setText] = useState(node?.text || "");

  const isTooLong = text.length > MAX_INSTAGRAM_TEXT_LENGTH;

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isTooLong) return;
    onSave(text);
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="flex flex-col">
        <Input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          fullWidth
          multiline
          minRows={4}
          error={isTooLong}
        />

        <FormHelperText error={isTooLong} className="text-right">
          {text.length} / {MAX_INSTAGRAM_TEXT_LENGTH}
        </FormHelperText>

        {isTooLong && (
          <FormHelperText error>
            Максимальная длина текста в Instagram — {MAX_INSTAGRAM_TEXT_LENGTH}{" "}
            символов
          </FormHelperText>
        )}

        <div className="mt-8">
          <Button variant="contained" type="submit" fullWidth disabled={isTooLong}>
            Сохранить
          </Button>
        </div>
      </form>
    </div>
  );
};

export default NodeTextForm;
